module.exports = __webpack_public_path__ + "img/privately-logo.8e181317.png";